import React from 'react'
import PropTypes from 'prop-types'
import {
  CircularProgress,
  Grid,
  Typography,
  TextField,
  InputAdornment,
  Fab,
  Tooltip,
  FormControlLabel,
  RadioGroup,
  FormControl,
  Radio,
  useTheme,
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import AutocompleteNative from '@material-ui/lab/Autocomplete'

import { SecaoGenerica, SelecionarData } from 'components'
import { useFormDocumento } from './hooks/useFormDocumento'
import { useStyles } from './FormDocumento.styles'

export const FormDocumento = (props) => {
  const { carregando, form, exame, idExameRealizado, setDisableBotaoAvancar, idExameSolicitado } = props
  const classes = useStyles()
  const theme = useTheme()

  const {
    arrayFiliacao,
    vestigiosExtraidosDeCadaver,
    processandoVestigiosExtraidosDeCadaver,
    mostrarFormularioDadosDocumento,
    mostrarTextoResultadoNegativo,
    handleAdicionarFiliacao,
    parseDataLocal,
    handleDateChange,
  } = useFormDocumento({
    exame,
    form,
    idExameSolicitado,
    idExameRealizado,
    setDisableBotaoAvancar,
  })

  return (
    <div>
      {carregando || processandoVestigiosExtraidosDeCadaver ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container>
          {mostrarFormularioDadosDocumento(vestigiosExtraidosDeCadaver) ? (
            <SecaoGenerica titulo="DADOS RETORNADOS DO SISTEMA OU DOCUMENTO CONFRONTADO">
              <Grid container spacing={2} className={classes.corpoFormulario}>
                <Grid item md={6} sm={6} xs={12} className={classes.item}>
                  <TextField
                    fullWidth
                    label="NÚMERO PROTOCOLO ABIS"
                    name="numeroProtocolo"
                    onChange={form.handleChange}
                    value={form.formState.values.numeroProtocolo || ''}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item md={6} sm={6} xs={12} className={classes.item}>
                  <AutocompleteNative
                    name="tipoDocumento"
                    noOptionsText="Sem informações"
                    options={[
                      'REGISTRO CIVIL',
                      'PRONTUÁRIO CIVIL',
                      'PRONTUÁRIO DE IDENTIFICAÇÃO CRIMINAL',
                      'CARTEIRA DE TRABALHO',
                      'CARTEIRA PROFISSIONAL',
                      'PASSAPORTE',
                      'CARTEIRA DE IDENTIFICAÇÃO FUNCIONAL',
                      'OUTRO',
                    ]}
                    value={form.formState.values.tipoDocumento || null}
                    onChange={(event, newValue) => {
                      form.handleChangeNewValueByNameProperty(event, newValue, 'tipoDocumento')
                    }}
                    getOptionLabel={(option) => option}
                    renderOption={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="TIPO DO DOCUMENTO CONFRONTADO"
                        error={form.hasError('tipoDocumento')}
                        helperText={
                          form.hasError('tipoDocumento') ? form.formState.errors.tipoDocumento[0] : null
                        }
                        required
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item md={6} sm={6} xs={12} className={classes.item}>
                  <TextField
                    fullWidth
                    label="Nº DO DOCUMENTO"
                    name="numeroDocumento"
                    onChange={form.handleChange}
                    value={form.formState.values.numeroDocumento || ''}
                    required
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item md={6} sm={6} xs={12} className={classes.item}>
                  <TextField
                    fullWidth
                    label="ÓRGÃO EMISSOR"
                    name="orgaoEmissorDocumento"
                    onChange={form.handleChange}
                    value={form.formState.values.orgaoEmissorDocumento || ''}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item md={12} sm={12} xs={12} className={classes.item}>
                  <TextField
                    fullWidth
                    label="NOME COMPLETO"
                    name="nome"
                    onChange={form.handleChange}
                    value={form.formState.values.nome || ''}
                    required
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item md={12} sm={12} xs={12} className={classes.groupFiliacao}>
                  {arrayFiliacao.map((input, index) => (
                    <TextField
                      key={input}
                      error={form.hasError(`${input}`)}
                      fullWidth
                      helperText={form.hasError(`${input}`) ? form.formState.errors[`${input}`][0] : null}
                      className={classes.inputForm}
                      label={`FILIAÇÃO (${index + 1})`}
                      name={input}
                      onChange={form.handleChange}
                      value={form.formState.values[input] || ''}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        endAdornment: index + 1 === arrayFiliacao.length && (
                          <InputAdornment position="start">
                            <Tooltip title="Adicionar filiação">
                              <Fab
                                color="primary"
                                size="small"
                                onClick={handleAdicionarFiliacao}
                                className={classes.botaoAddFiliacao}
                              >
                                <AddIcon />
                              </Fab>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                    />
                  ))}
                </Grid>

                <Grid item md={6} sm={6} xs={12} className={classes.item}>
                  <TextField
                    fullWidth
                    label="NATURALIDADE"
                    name="naturalidade"
                    onChange={form.handleChange}
                    value={form.formState.values.naturalidade || ''}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item md={6} sm={6} xs={12} className={classes.item}>
                  <Typography variant="body2" style={{ marginBottom: '8px' }}>
                    SEXO
                  </Typography>
                  <FormControl component="fieldset" fullWidth>
                    <RadioGroup
                      aria-label="sexo"
                      name="sexo"
                      value={form.formState.values.sexo || 'DESCONHECIDO'}
                      onChange={form.handleChange}
                      style={{ display: 'flex', flexDirection: 'row' }}
                    >
                      <FormControlLabel
                        value="MASCULINO"
                        control={<Radio />}
                        label={<Typography variant="body2">MASCULINO</Typography>}
                      />
                      <FormControlLabel
                        value="FEMININO"
                        control={<Radio />}
                        label={<Typography variant="body2">FEMININO</Typography>}
                      />
                      <FormControlLabel
                        value="DESCONHECIDO"
                        control={<Radio />}
                        label={<Typography variant="body2">DESCONHECIDO</Typography>}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item md={12} sm={12} xs={12} className={classes.item}>
                  <SelecionarData
                    dataBD={
                      form.formState.values.dataNascimentoFormatada
                        ? parseDataLocal(form.formState.values.dataNascimentoFormatada)
                        : null
                    }
                    callback={handleDateChange}
                    label="DATA DE NASCIMENTO"
                    required
                    withoutTime
                    shrink
                    md={6}
                    sm={6}
                    xs={12}
                  />
                  {!form.formState.values.dataNascimentoFormatada && (
                    <Typography
                      style={{ fontSize: '11px', color: theme.palette.error.main, marginTop: '4px', paddingLeft: '8px' }}
                    >
                      Campo obrigatório
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </SecaoGenerica>
          ) : (
            <Grid item md={12} sm={12} xs={12} className={classes.labelSemDados}>
              <Typography variant="h6">
                {mostrarTextoResultadoNegativo(vestigiosExtraidosDeCadaver)}
              </Typography>
            </Grid>
          )}
        </Grid>
      )}
    </div>
  )
}

FormDocumento.propTypes = {
  carregando: PropTypes.bool,
  exame: PropTypes.object.isRequired,
  form: PropTypes.shape({
    formState: PropTypes.shape({
      values: PropTypes.object.isRequired,
      errors: PropTypes.object.isRequired,
    }).isRequired,
    setFormState: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleChangeNewValueByNameProperty: PropTypes.func.isRequired,
    hasError: PropTypes.func.isRequired,
  }).isRequired,
  idExameRealizado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  idExameSolicitado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setDisableBotaoAvancar: PropTypes.func.isRequired,
}
